<section class="about-page">
  <app-header />

  <main class="about-page__content">
    <section class="about-page__hero">
      <div class="about-page__image">
        <img
          src="/images/image.png"
          alt="Daria Soloveva"
        >
      </div>
    </section>

    <section class="about-page__text-section">
      <div class="about-page__text">
        <p>
          UX/UI Designer with 8+ years of experience designing <br>
          end-to-end digital products for B2B and B2C platforms across web <br>
          and mobile. I specialize in creating intuitive, scalable digital <br>
          experiences that balance user needs with business objectives.
        </p>

        <p>
          I’m passionate about combining structured thinking, attention <br>
          to detail, and a strong focus on usability and interaction design. <br>
          I collaborate closely with cross-functional teams — product, <br>
          developers and stakeholders across the full product lifecycle. <br>
          I focus on bringing clarity to complex problems and shaping them <br>
          into intuitive product experiences.
        </p>
      </div>
    </section>
  </main>

  <app-mobile-menu />
</section>
